import { api, apiUrl } from "./../../api/index";

const url = `${apiUrl}/rankings`;

export const fetchRankings = () => {
  return api(url, {
    method: "GET",
  });
};
